<template>
  <hic-dialog append-to-body title="数据库链接编辑" :visible="visible" @close="cancel" top="6vh" width="50rem" @open="open" :close-on-click-modal="false">
    <el-form :model="value" :rules="comRules" ref="submitForm" label-width="7rem" label-position="right" style="padding-right: 3rem">
      <el-row>
        <el-col :span="12">
          <el-form-item label="编码" prop="code">
            <el-tag v-if="value.id" type="primary" style="width: 100%"
              ><b>{{ value.code }}</b></el-tag
            >
            <el-input v-else size="small" type="text" placeholder="请输入编码" v-model.trim="value.code"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input size="small" type="text" placeholder="请输入名称" v-model.trim="value.name" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户名" prop="username">
            <el-input size="small" type="text" placeholder="请输入用户名" v-model.trim="value.username" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="密码" prop="password">
            <el-input size="small" type="text" placeholder="请输入密码" v-model.trim="value.password" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="数据类型" prop="type">
            <hic-dict-selector dict-type="DataBaseType" placeholder="请选择数据类型" v-model="value.type" is-enum class="edit-thin right-pad" />
            <small v-if="value.type == 'PostgreSQL'" class="info"> 参考：jdbc:postgresql://server:port/dbName</small>
            <small v-if="value.type == 'Oracle'" class="info"> 参考：jdbc:oracle:thin:@server:port:dbName</small>
            <small v-if="value.type == 'MySQL'" class="info"> 参考：jdbc:mysql://server:port/dbName</small>
            <small v-if="value.type == 'SQLServer'" class="info"> 参考：jdbc:sqlserver://server:port;databaseName=dbName</small>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="连接字符串" prop="uri">
            <el-input type="textarea" :rows="5" v-model="value.uri" placeholder="请输入连接字符串" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row slot="footer" type="flex" justify="space-between" align="middle">
      <div>
        <el-button type="warning" @click="runTest" :loading="meta.loading" size="small" class="right-pad" icon="el-icon-odometer">测 试</el-button>
        <span v-if="resultVal" :class="{ danger: resultVal.indexOf('失败') > -1, success: resultVal.indexOf('成功') > -1 }">{{ resultVal }}</span>
      </div>
      <div>
        <el-button type="info" @click="cancel">关 闭</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-row>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      value: Object,
    },
    data() {
      return {
        meta: {
          loading: false,
        },
        comRules: {
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          code: [{ required: true, message: "请输入编码", trigger: "blur" }],
          uri: [{ required: true, message: "请输入连接字符串", trigger: "blur" }],
          type: [{ required: true, message: "请选择类型", trigger: "change" }],
        },
        resultVal: "",
      };
    },
    computed: {
      ...mapGetters(["dict", "user", "dictEnum", "Enum"]),
    },
    methods: {
      open() {
        try {
          this.$set(this, "resultVal", "");
          this.$refs.submitForm.resetFields();
        } catch (error) {}
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      save() {
        this.$refs.submitForm.validate().then((valid) => {
          if (valid) {
            this.meta.loading = true;
            api.PxyDb.save(this.value)
              .then((res) => {
                this.$message.success("保存成功!");
                this.$store.dispatch("loaders", "DataLink");
                this.$emit("close");
                this.cancel();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          }
        });
      },
      runTest() {
        this.$refs.submitForm.validate().then((valid) => {
          if (valid) {
            this.meta.loading = true;
            api.PxyDb.testSql(this.value)
              .then((res) => {
                console.log("res===", res);
                this.resultVal = "测试成功!";
              })
              .catch((err) => {
                this.resultVal = "测试失败!";
              })
              .finally(() => {
                this.meta.loading = false;
              });
          }
        });
      },
    },
  };
</script>
